export default __webpack_public_path__ + "static/media/subcategory_car_6.f13200a8.png";